import { createFileRoute, Link } from '@tanstack/react-router'
import { getVendorSectionConfig, isVendorSectionRoute } from '@/features/setup/vendor-section-data'
import { VendorSectionPage } from '@/features/setup/vendor-section-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/setup/$vendorSectionSlug')({
  component: VendorSectionRoute,
})

function VendorSectionRoute() {
  const { workspaceSlug, vendorSectionSlug } = Route.useParams()

  if (!isVendorSectionRoute(vendorSectionSlug)) {
    return (
      <section className="mx-auto max-w-2xl rounded-lg border bg-card p-6 text-center shadow-sm">
        <h1 className="font-heading text-2xl text-foreground">Sekce nenalezena</h1>
        <p className="mt-2 text-sm text-muted-foreground">Tahle část dotazníku zatím neexistuje.</p>
        <ButtonLink workspaceSlug={workspaceSlug} />
      </section>
    )
  }

  const config = getVendorSectionConfig(vendorSectionSlug)

  if (!config) {
    return (
      <section className="mx-auto max-w-2xl rounded-lg border bg-card p-6 text-center shadow-sm">
        <h1 className="font-heading text-2xl text-foreground">Sekce nenalezena</h1>
        <p className="mt-2 text-sm text-muted-foreground">
          Tahle část dotazníku zatím nemá konfiguraci.
        </p>
        <ButtonLink workspaceSlug={workspaceSlug} />
      </section>
    )
  }

  return <VendorSectionPage workspaceSlug={workspaceSlug} config={config} />
}

function ButtonLink({ workspaceSlug }: { workspaceSlug: string }) {
  return (
    <Link
      to="/w/$workspaceSlug"
      params={{ workspaceSlug }}
      className="mt-5 inline-flex h-9 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground"
    >
      Zpět na přehled
    </Link>
  )
}
